import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Select } from "antd"
import { Label } from "reactstrap"


class FilterPartner extends Component {
    _handleChangeStatus = (name, value) => {
        const { onChangeFilter } = this.props

        if (typeof onChangeFilter === 'function') {
            onChangeFilter(name, value)
        }
    }
    _handleChange = async (value) => {
        await this.typeSelect.blur()
        this._handleChangeStatus('partner',value)
    }

    render() {
        const { partner, selectOptions } = this.props
        return (
            <div className="FilterPartner">
                <div className="MultiSelect">
                    <Label style={{whiteSpace: "nowrap"}}>Partner sản xuất</Label>
                    <Select
                       showSearch
                        mode="multiple"
                        style={{ minWidth: '200px' }}
                        placeholder='Chọn partner sản xuất'
                        defaultValue={partner}
                        ref={(select) => this.typeSelect = select}
                        onChange={this._handleChange}
                        options={selectOptions}
                        optionFilterProp="children"
                        filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                    />   
                    
                </div>
            </div>
        )
    }
}

FilterPartner.propTypes = {
    procedure: PropTypes.any,
    onChangeFilter: PropTypes.func
}

export default FilterPartner